import React, { useEffect } from 'react';
import InputType from './ComponentsTpes/InputType';

const ExitButton =   ({  fieldsData, componentSourceOptions ,
    selectedPorts, setSelectedPorts, savedData, setSavedData}) => {

    const selectOptions = (key, value) => {
        setSavedData(prevData => {
            return {
                ...prevData,
                Exit_button:{
                    ...prevData.Exit_button,
                    [key]: value
                }
            }
        })
    }

    return (<InputType
        setSelectedPorts={setSelectedPorts}
        selectedPorts={selectedPorts}
        source={componentSourceOptions.inputsData}
        selectOptions={selectOptions}
        component_source={savedData.Exit_button.component_source.value}
        condition={savedData.Exit_button.condition}
        input={savedData.Exit_button.input}
        name={savedData.Exit_button.name}
        fieldsData={fieldsData}
    />)
}

export default ExitButton;